// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__a5Idj","skeleton-loading":"skeleton_skeleton-loading__nj7J8"};